enum ANALYTICS_EVENT {
	ADD = 'add',
	VIEW = 'view',
	PAGE_VIEW = 'page_view',
	CLICK = 'click',
	CREATE = 'create',
	DOWNLOAD = 'download',
	REGISTER = 'register',
	SEARCH = 'search',
	SHARE = 'share',
	EDIT = 'edit',
	DELETE = 'delete',
	REGISTRATION_COMPLETE = 'registrationComplete',
}

const ANALYTICS_PLATFORM = 'web'

type AnalyticsEventParams = Record<string, string> & {
	platform: typeof ANALYTICS_PLATFORM
	client?: string
	context?: string
	element?: string
	title?: string
	id?: string
	destination?: string
	scope?: string
	type?: string
	referer?: string
	query?: string
	channel?: string
	action?: string
	num?: string
}

export { ANALYTICS_EVENT, ANALYTICS_PLATFORM }
export type { AnalyticsEventParams }
